export default {
    name: 'fade',
    initial: {
        opacity: 0,
    },
    completed: {
        opacity: 1,
    },
};
